import { taskInternalPartnerFileThumbnailTypeDef } from "./task-internal-partner-file-thumbnail-type-def";

export const taskInternalPartnerFileTypeDef = `
    id
    taskId
    name
    size
    extension
    createdAt
    updatedAt
    removedAt
    type
    src
    thumbnails {
      ${taskInternalPartnerFileThumbnailTypeDef}
    }
`;
